// extracted by mini-css-extract-plugin
export default {"root":"CancelSubscription_root__8Ntg1","container":"CancelSubscription_container__4T4uC"};